<template>
  <div class="east-search-item-group">
    <div class="central__group-item" :title="group.title">
      <span>
        <span class="span-ellipsis">{{ group.title }}</span>
      </span>
    </div>
    <div class="central__item" v-for="item in group.items" @click="handleItemClick(item.id)">
      <div class="central__item__icon">
        <nuttrema-iconica-kcal
           className="iconica--small"
          :text="item.name"
          :image="getImagePath(item)"
          :nutrientDefinition="item.NutritionInfo">
        </nuttrema-iconica-kcal>
      </div>
      <div class="central__item__text" :title="`${item.name}${_get(item, 'Manufacturer.name') ? ', ' + $t('label.manufactured_by', { manufacturer: _get(item, 'Manufacturer.name')}) : ''}`">
        <div class="central__item__title">
          <span>
            <span class="span-ellipsis">{{ getTitle(item.name, 'title') }}</span>
          </span>
        </div>
        <div v-if="getTitle(item.name, 'subtitle')" class="central__item__description">
          <span>
            <span class="span-ellipsis">
              {{ getTitle(item.name, 'subtitle') }}<template v-if="_get(item, 'Manufacturer.name')">, <em>{{ _get(item, 'Manufacturer.name') }}</em></template>
            </span>
          </span>
        </div>
      </div>
      <div class="central__item__info">

      </div>
      <div v-if="_get(item, 'Allergens')" class="central__item__info">
        <nuttrema-allergens-info :allergens="_get(item, 'Allergens')" trigger="hover"></nuttrema-allergens-info>
      </div>
      <div class="central__item__action">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import { splitByComma } from 'utils';

import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';
import NuttremaAllergensInfo from 'components/ui/allergens/nuttrema-allergens-info';

export default {
  name: 'east-search-item-group',
  props: {
    group: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaIconicaKcal,
    NuttremaAllergensInfo,
  },
  methods: {
    getImagePath(item) {
      return !isNil(item.Image) ? `${process.env.IMAGES_ROOT}${item.Image.path}${item.Image.thumbnails.large.filename}` : '';
    },
    getTitle(text, type) {
      return splitByComma(text, type);
    },
    handleItemClick(id) {
      this.$emit('itemClick', id);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~assets/styles/theme/colors';

  .span-ellipsis {
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    text-overflow: ellipsis;
    top: 0; left: 0; bottom: 0; right: 0;
  }

  .east-search-item-group {
    display: flex;
    flex-shrink: 0;
    align-self: stretch;
    flex-direction: column;

    .central__group-item {
      display: flex;
      flex-shrink: 0;
      align-self: stretch;
      flex-direction: column;
      justify-content: flex-end;
      padding: 0.75em 0.75em 0.15em;
      border-bottom: 1px solid #DBE2EF;
      > span {
        display: flex;
        font-weight: 600;
        color: $gray-light;
        position: relative;
        height: 1.5em;
      }
    }

    .central__item {
      align-self: stretch;
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: space-between;

      color: $gray;
      padding: 0.5em 0.75em;
      background-color: #fff;
      border-bottom: 1px solid #DBE2EF;

      &:hover {
        cursor: pointer;
        background-color: rgba(#ffdd57, 0.25);
      }

      .central__item__icon {
        display: flex;
        flex-shrink: 0;
        margin-right: 0.75em;
      }

      .central__item__text {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 0.75em;

        .central__item__title, .central__item__description {
          display: flex;
          align-self: stretch;
          position: relative;
          > span {
            display: flex;
          }
        }

        .central__item__title {
          > span {
            font-weight: 500;
            height: 1.5em;
          }
        }

        .central__item__description {
          > span {
            font-size: 0.95rem;
            height: 1.35em;
            color: $gray-light;
            em {
              font-size: 0.8em;
              text-transform: uppercase;
            }
          }
        }
      }

      .central__item__info {
        display: flex;
        flex-shrink: 0;
        margin-right: 0.75em;
      }

      .central__item__action {
        flex-shrink: 0;
        display: flex;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/search/east-search-item-group.vue